<template>
    <div class="ManagementRole" style="padding:30px;
     background: #FFFFFF;

   border-radius: 10px;">
        <h4>角色管理</h4>
        <el-button class="addRole" @click="addRole()">新建角色</el-button>
        <el-table border
            :data="tableData" max-height="500px"
            tooltip-effect="dark" :header-cell-style="{background:'#F3F3F3'}"
            ref="multipleTable"
            style="width: 97%;margin-left:17px;" >
            <el-table-column type="index" label="序号" width="60px" min-width="8%"></el-table-column>
            <el-table-column prop="cnName" label="角色中文名" min-width="10%"></el-table-column>
            <el-table-column prop="enName" label="角色英文名" min-width="10%"></el-table-column>
            <el-table-column prop="statuss" label="状态" min-width="10%"></el-table-column>
            <el-table-column prop="remark" label="备注" min-width="10%"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="10%"></el-table-column>
            <el-table-column prop="operation" label="操作" min-width="10%">
              <template slot-scope="scope">
                <el-button @click="amend(scope)" type="text" size="small">修改</el-button>
                <el-button @click="gobalbuyer(scope)" type="text" size="small">查看权限</el-button>
                <el-button @click="PermisAssign(scope)" type="text" size="small">权限分配</el-button>
              </template>
            </el-table-column>
        </el-table>
        <div class="panelBox" v-show="panelBox">
            <div class="panel">
                <i class="el-icon-circle-close close" @click="closePanel()"></i>
                <h4 v-if="addPanel">新建角色</h4>
                <h4 v-else>修改角色</h4>
                <el-form ref="roleForm" :label-position="labelPosition" :rules="rules" :model="roleForm"
                label-width="80px" size="mini" hide-required-asterisk>
                    <el-form-item label="中文名" prop="cnName">
                        <el-input v-model="roleForm.cnName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="英文名" prop="enName">
                        <el-input v-model="roleForm.enName" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select v-model="roleForm.status" placeholder="请选择状态">
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="未启用" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="描述" prop="remark" style="min-height: 80px;">
                        <el-input type="textarea" v-model="roleForm.remark" style="min-height: 80px;"></el-input>
                    </el-form-item>
                    <el-row v-if="addPanel">
                        <el-button size="small" @click="goonadd('roleForm')">确认并继续新建</el-button>
                        <el-button size="small" @click="addRoleend('roleForm')">确认新建</el-button>
                    </el-row>
                    <el-row v-else>
                        <el-button size="small" @click="amendend('roleForm')">确认修改</el-button>
                    </el-row>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
export default {
    name:"ManagementRole",
    data() {
        return {
            labelPosition: 'left',
            tableData:[
                {
                    // cnName:"",
                    // enName:"",
                    // status:"",
                    // remark:"",
                    // createTime:"",
                    // createUser:"",//创建人
                    // id:"",//主键
                }
            ],
            roleForm:{
                cnName:"",
                enName:"",
                id:'',
                status:"1",
                remark:"",
            },
            rules: {
                cnName: [
                    { required: true, message: '请输入中文名', trigger: 'blur' }
                ],
                enName: [
                    { required: true, message: '请输入英文名', trigger: 'blur' }
                ],
                status: [
                    { required: true, message: '请至少选择一个状态', trigger: 'blur' }
                ],
                remark: [
                    { required: true, message: '请输入描述', trigger: 'blur' }
                ]
            },
            panelBox:false,//弹框显示
            addPanel:true,//控制添加修改
        }
    },
    watch: {},
    methods: {
        addRole() {//新建角色
            this.panelBox = true;
            this.addPanel = true;
            this.roleForm = {
                cnName:"",
                enName:"",
                id:null,
                status:"1",
                remark:"",
            }
        },
        amend(data){//table修改
            // console.log(data);
            this.panelBox = true;
            this.addPanel = false;
            this.roleForm.cnName = data.row.cnName;
            this.roleForm.enName = data.row.enName;
            this.roleForm.status = data.row.status+"";
            this.roleForm.remark = data.row.remark;
            this.roleForm.id = data.row.id;
        },
        gobalbuyer(data){//table查看权限
            // console.log(data.row.id);
            this.$router.push({name: 'PermissionAssignment', query: {'roleid': data.row.id,'cnName':data.row.cnName,'enName':data.row.enName,'type':"查看权限"}});
        },
        PermisAssign(data){//table权限分配
            // console.log(data);
            this.$router.push({name: 'PermissionAssignment', query: {'roleid': data.row.id,'cnName':data.row.cnName,'enName':data.row.enName,'type':"权限分配"}});
        },
        closePanel(){//关闭弹框
            this.panelBox = false;
        },
        goonadd(roleForm){//确认新建并继续新建
            this.$refs[roleForm].validate((valid) => {

                if (valid) {
                    this.addRolerequest();
                    this.panelBox = true;
                    this.$refs[roleForm].resetFields();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        addRoleend(roleForm){//确认新建
            this.$refs[roleForm].validate((valid) => {
                if (valid) {
                    this.addRolerequest();
                    this.closePanel();
                    // this.Notifications()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        amendend(roleForm){//确认修改
         this.$refs[roleForm].validate((valid) => {

                if (valid) {
                    this.addRolerequest();

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            // this.closePanel();
            // this.addRolerequest();
        },
        Notifications(data){//消息提示
            this.$message({
                message: data
            });
        },
        getRoleAlldata(){//角色所有的数据
            let params = {
                "roleName": "",
                "status":""
            };
            let that = this;
            that.axios.get(
                "/authorization/getSubAccountRoleList",
                {params}
            )
            .then((response)=> {
                console.log(response.data.datas);//.data.datas
                that.tableData = response.data.datas;
                for(var i=0;i<that.tableData.length;i++){
                    if(that.tableData[i].status == 0){
                        that.tableData[i].statuss = "未启用";
                    }else if(that.tableData[i].status == 1){
                        that.tableData[i].statuss = "启用";
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        },
        addRolerequest(){//新建角色/修改角色
            let data= {
                "cnName": this.roleForm.cnName,
                "enName": this.roleForm.enName,
                "id": this.roleForm.id,
                "remark": this.roleForm.remark,
                "status": this.roleForm.status
            };
            // console.log(data)
            let that = this;
            that.axios.post(
                "/authorization/saveOrUpdateRoleInfo",
                data
            )
            .then((response)=> {


                that.Notifications(response.data.message);
                if(response.data.message == "成功"){//
                    this.getRoleAlldata();
                     this.panelBox = false;
                    this.$refs[roleForm].resetFields();
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    },
    created () {},
    mounted () {
        this.getRoleAlldata();
    },
}
</script>
<style>
.ManagementRole{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden;
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;

}
.ManagementRole h4{
    width: 100px;
    height: 23px;
    margin-top: 10px;
    margin-left: 17px;
    font-size: 24px;
    font-family: "PingFang SC";
    font-weight: bold;
    color: #333333;
}
.ManagementRole .addRole{
    display: block;
    width: 150px;
    height: 40px;
    margin-top: 36px;
    margin-bottom: 21px;
    margin-left: 17px;
    font-size: 16px;
    background: #FFFFFF;
    color: #FF4D01;
    border: 1px solid #FF4D01;
    border-radius: 5px;
}
/* ---------------------弹框---------------------- */
.ManagementRole .panelBox{
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.35);
    z-index: 2;
}
.ManagementRole .panelBox .panel{
    position: absolute;
    top: calc(50% - 250px);
    left: calc(50% - 260px);
    width: 520px;
    height: 500px;
    background: #fff;
    border-radius: 10px;
}
.ManagementRole .panelBox .panel h4{
    margin-top: 25px;
    margin-left: 27px;
}
.ManagementRole .panelBox .panel i.close{
    position: absolute;
    top: 25px;
    right: 20px;
    font-size: 24px;
}
.ManagementRole .panelBox .panel i:hover{
    color: #409EFF;
}
.ManagementRole .panelBox .el-form .el-form-item--mini.el-form-item, .ManagementRole .panelBox .el-form-item--small.el-form-item{
    width: 86%;
    margin-left: 5%;
    margin-top: 33px;
    margin-bottom: 25px;
}
.ManagementRole .panelBox .el-textarea__inner{
    min-height: 80px!important;
}
.ManagementRole .panelBox .el-input--mini .el-input__inner{
    height: 34px;
    line-height: 34px;
}
.ManagementRole .panelBox .el-button--small, .ManagementRole .panelBox .el-button--small.is-round{
    width: 173px;
    height: 40px;
    margin-right: 8px;
    color: #FF4D01;
    border: 1px solid #FF4D01;
    border-radius: 5px;
}
.ManagementRole .panelBox .el-row{
    margin-left: 106px;
}
.ManagementRole .panelBox .el-button--small:hover,
.ManagementRole .panelBox .el-button--small.is-round:hover,
.ManagementRole .addRole:hover{
    background: #FF4D01;
    color: #fff;
}
/* -------------------element -------------------- */
.ManagementRole .el-table td, .el-table th{
    text-align: center;
}
/* table 滚动条 */
.ManagementRole .el-table__body-wrapper::-webkit-scrollbar{
    width: 3px;
}
.ManagementRole .el-table__body-wrapper::-webkit-scrollbar-thumb{
    border-radius: 2px;
    height: 50px;
    background: #409EFF;
}
.ManagementRole .el-table__body-wrapper::-webkit-scrollbar-track{
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/ManagementRole.vue